import Image from "next/image";
import dynamic from "next/dynamic";
const BlogCards = dynamic(() => import("@/Components/DataDisplayCompoants/BlogCard"), { ssr: true });
const GreenCards = dynamic(() => import("@/Components/DataDisplayCompoants/GreenCard"), { ssr: true });
const MobileSlider = dynamic(() => import("./mobileSlider"), { ssr: true });

type ServicesAiProps = {
  isMobile?: boolean;
  data?: any;
};

const startIndex = 2; // the first green card (1-based index)
const interval = 3;

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

const ServicesAi: React.FC<ServicesAiProps> = ({ data }) => {
  const cards = data?.Cards;

  // Guard: don't render if there are no cards
  if (!cards || cards.length === 0) return null;

  const renderCards = (classname: string, lineClamp?: number) =>
    cards.map((card: any, index: number) => {
      const cardIndex = index + 1;
      const isGreen =
        (cardIndex - startIndex) % interval === 0 && cardIndex >= startIndex;

      return (
        <div key={index} className="col-span-4">
          {isGreen ? (
            <GreenCards
              title={card?.title}
              details={card?.description}
              label={card?.link?.label}
              link={card?.link?.href}
              classname={classname}
              lineClamp={lineClamp}
            />
          ) : (
            <BlogCards
              title={card?.title}
              details={card?.description}
              label={card?.link?.label}
              link={card?.link?.href}
              classname={classname}
              lineClamp={lineClamp}
              imageUrl={`${baseUrl}${card?.image?.data?.attributes?.url}`}
            />
          )}
        </div>
      );
    });

  return (
    <section className="relative bg-[url(/images/enterprise-bg.png)] bg-size-[60%] bg-no-repeat bg-left-top text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
      <Image
        src="/images/consulting/bg-ai-services.png"
        width={748}
        height={748}
        alt="banner-vector"
        className="absolute w-[748px] h-[748px] top-0 right-0 bottom-0 m-auto left-0 z-0 bg-cover bg-no-repeat bg-center"
        quality={80}
        loading="eager"
        priority
      />
      <div className="absolute z-[-1] top-0 right-0 w-full h-full bg-[linear-gradient(96.18deg,#E6F5FF_0%,#5AA7DF_100%),linear-gradient(0deg,rgba(255,255,255,0.8),rgba(255,255,255,0.8))]">
        <div className="w-full h-full bg-[linear-gradient(0deg,_rgba(255,_255,_255,_0.8),_rgba(255,_255,_255,_0.8))]" />
      </div>

      <div className="md:container mx-auto md:px-4 text-left relative z-10">
        {/* Desktop grid — hidden on mobile via CSS */}
        <div className="hidden md:grid grid-cols-12 gap-[30px]">
          {renderCards("xl:h-[485px] md:h-[338px] bg-green-ai-consulting")}
        </div>

        {/* Mobile slider — hidden on tablet+ via MobileSlider's own md:hidden class */}
        <MobileSlider>
          {renderCards("h-[402px]", 5)}
        </MobileSlider>
      </div>
    </section>
  );
};

export default ServicesAi;
